import type { AiRiskUiBand } from "../../types/aiSuggestion";
import { staticRiskPercentLabel } from "../../utils/aiSuggestionDisplay";

type RiskBadgeProps = {
  readonly band: AiRiskUiBand;
  /** When set (e.g. API confidence), overrides static band placeholder. */
  readonly percentLabel?: string | null;
  readonly className?: string;
};

const shellClass: Record<AiRiskUiBand, string> = {
  legal: "border-risk-legal bg-risk-legal-bg text-risk-legal",
  business: "border-risk-business bg-risk-business-bg text-risk-business",
  exec: "border-risk-exec bg-risk-exec-bg text-risk-exec",
  red: "border-risk-red bg-risk-red-bg text-risk-red",
  amber: "border-risk-amber bg-risk-amber-bg text-risk-amber",
  green: "border-risk-green bg-risk-green-bg text-risk-green",
};

export const RiskBadge = ({
  band,
  percentLabel,
  className = "",
}: RiskBadgeProps) => {
  const label = percentLabel?.trim() || staticRiskPercentLabel(band);
  return (
    <span
      className={`inline-flex min-w-[2.75rem] justify-center rounded-full border px-2 py-0.5 text-xs font-semibold transition-all duration-200 ease-in-out ${shellClass[band]} ${className}`.trim()}
    >
      {label}
    </span>
  );
};
